import React from 'react'
import { Table } from 'antd'
import type { CorporateExpandViewInterface } from '../../../../Types/Client/RegisteredClients/Corporate'
import commontStyles from '../../../../Utils/Common.less'

const CoporateExpandView = (
    props: CorporateExpandViewInterface
): React.ReactElement => {
    const { corporateData } = props

    const columns = [
        {
            title: 'Name',
            dataIndex: 'contactName',
        },
        {
            title: 'Contact No',
            dataIndex: 'mobileNumber',
        },
        {
            title: 'Email',
            dataIndex: 'emailAddress',
        },
        {
            title: 'Alter Email',
            dataIndex: 'alternativeEmailAddress',
        },
    ]

    const dataSource = [
        {
            key: '1',
            contactName: corporateData.contactName,
            mobileNumber: corporateData.mobileNumber,
            emailAddress: corporateData.emailAddress,
            alternativeEmailAddress: corporateData.alternativeEmailAddress,
        },
    ]

    return (
        <div className={commontStyles.expandCard}>
            <Table
                columns={columns}
                dataSource={dataSource}
                pagination={false}
            />
        </div>
    )
}

export default CoporateExpandView
